import React, {useEffect, useState} from 'react';
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import NotNullCheck from "../../util/NotNullCheck";
import EndUseAgreementTTNETCheckbox from "../../component/custom/EndUseAgreementTTNETCheckbox";
import {UAParser} from "ua-parser-js";
import OnboardDialog from "../../component/base/onboard-dialog-component/OnboardDialog";
import {DeepLinker} from "../../util/DeepLinker";

const LoginWithMobilApp = (props) => {
    const {t, i18n} = props.props;

    const [error, setError] = useState(null);
    const [approve, setApprove] = useState(null);
    const [dialog, setDialog] = useState({
        visible: false,
        title: "",
        content: "",
    });
    const redirectDeepLink = "thy://launch";

    const validation = () => {
        if (NotNullCheck(control()))
            redirect();
    }

    const redirect = () => {
        let os = new UAParser().getResult()?.os?.name;
        if (os === null || os === undefined)
            return;

        if (os.toLowerCase() === 'android') {
            //Android
            let linker = new DeepLinker({
                onIgnored: function () {
                    showDialog();
                },
                onFallback: function () {
                },
                onReturn: function () {
                }
            });
            linker.openURL(redirectDeepLink);
        } else {
            if (new UAParser().getResult()?.browser?.name?.toLowerCase() === "safari") {
                //IOS Safari
                let linker = new DeepLinker({
                    onIgnored: function () {
                    },
                    onFallback: function () {
                        if (getStorage("appOpen") === null)
                            showDialog();
                    },
                    onReturn: function () {
                        increaseStorage("appOpen");
                    }
                });
                linker.openURL(redirectDeepLink);
            } else {
                //IOS Other
                let linker = new DeepLinker({
                    onIgnored: function () {
                        let s = getStorage("appOpen");
                        let s2 = getStorage("appOpen2");
                        if (s === null) {
                            if (s2 !== null && s2 > 1)
                                showDialog();
                        } else localStorage.removeItem("appOpen");
                    },
                    onFallback: function () {
                    },
                    onReturn: function () {
                        increaseStorage("appOpen");
                    }
                });

                linker.openURL(redirectDeepLink);

                increaseStorage("appOpen2");
            }
        }
    }

    const getStorage = (key) => {
        let s = localStorage.getItem(key);
        if (s === null || s === undefined)
            return null;
        return parseInt(s);
    }

    const setStorage = (key, val) => {
        localStorage.setItem(key, val);
    }

    const increaseStorage = (key) => {
        let s = getStorage(key);
        if (s !== null) {
            s = s + 1;
            setStorage(key, s);
        } else setStorage(key, 1);
    }

    const showDialog = () => {
        setDialog({
            visible: true,
            title: t('login.mobile_not_redirect_title'),
            content: t('login.mobile_not_redirect_content'),
        });
    }

    const control = () => {
        let valid = {
            approve: (approve == null || !approve) ? t('error.empty_approve') : null
        };
        setError(valid);
        return valid;
    }

    useEffect(() => {
        if (error !== null) {
            control();
        }
    }, [i18n.language])

    return (
        <div>
            <p className="login-with-mobil-app-title">{t('login.mobil_app_title')}</p>
            <p className="login-with-mobil-app-context">{t('login.mobil_app_content')}</p>

            <div className="h-20"/>

            <EndUseAgreementTTNETCheckbox value={approve}
                                          error={error?.approve}
                                          onChange={(e) => setApprove(e)}
            />

            <div className="h-20"/>

            <OnboardButton label={t('login.connect')}
                           onClick={() => validation()}/>

            <OnboardDialog error={true}
                           visible={dialog.visible}
                           title={dialog.title}
                           content={dialog.content}
                           cancelShow cancelText={t('home.close')}
                           onClickCancel={() => setDialog({...dialog, visible: false})}
            />

        </div>
    );
};

export default LoginWithMobilApp;

